// Common search query: /seo-cost → /pricing (301).
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/seo-cost")({
  beforeLoad: () => {
    throw redirect({ to: "/pricing", statusCode: 301 });
  },
});
